/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationRoleRead } from './OrganizationRoleRead';
import {
    OrganizationRoleReadFromJSON,
    OrganizationRoleReadFromJSONTyped,
    OrganizationRoleReadToJSON,
    OrganizationRoleReadToJSONTyped,
} from './OrganizationRoleRead';

/**
 * An organization a user belongs to (superadmin user reads).
 * 
 * `roles` are the user's active roles there and `inactive_roles` the inactive ones (each sorted
 * by id). `membership_active` is the membership status there: active when any non-superadmin
 * row is active, or, when the user holds only superadmin rows there, when one of those is.
 * @export
 * @interface UserOrganizationRead
 */
export interface UserOrganizationRead {
    /**
     * 
     * @type {string}
     * @memberof UserOrganizationRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserOrganizationRead
     */
    name: string;
    /**
     * 
     * @type {Array<OrganizationRoleRead>}
     * @memberof UserOrganizationRead
     */
    roles?: Array<OrganizationRoleRead>;
    /**
     * 
     * @type {Array<OrganizationRoleRead>}
     * @memberof UserOrganizationRead
     */
    inactive_roles?: Array<OrganizationRoleRead>;
    /**
     * 
     * @type {boolean}
     * @memberof UserOrganizationRead
     */
    membership_active?: boolean;
}

/**
 * Check if a given object implements the UserOrganizationRead interface.
 */
export function instanceOfUserOrganizationRead(value: object): value is UserOrganizationRead {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UserOrganizationReadFromJSON(json: any): UserOrganizationRead {
    return UserOrganizationReadFromJSONTyped(json, false);
}

export function UserOrganizationReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserOrganizationRead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(OrganizationRoleReadFromJSON)),
        'inactive_roles': json['inactive_roles'] == null ? undefined : ((json['inactive_roles'] as Array<any>).map(OrganizationRoleReadFromJSON)),
        'membership_active': json['membership_active'] == null ? undefined : json['membership_active'],
    };
}

export function UserOrganizationReadToJSON(json: any): UserOrganizationRead {
    return UserOrganizationReadToJSONTyped(json, false);
}

export function UserOrganizationReadToJSONTyped(value?: UserOrganizationRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(OrganizationRoleReadToJSON)),
        'inactive_roles': value['inactive_roles'] == null ? undefined : ((value['inactive_roles'] as Array<any>).map(OrganizationRoleReadToJSON)),
        'membership_active': value['membership_active'],
    };
}

